// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__c-nmb","lastLink":"HeadPage_lastLink__nya1t"};